function initiateGinTypeSelector() {
  document
    .querySelectorAll('.gin-type-selection-block')
    .forEach(block => {
      new window.GinTypeSelection(block);
    });
}

if (!window.GinTypeSelection) {
  window.GinTypeSelection =
    class GinTypeSelection {
      constructor(blockElement) {
        this.blockElement = blockElement;
        this.typeOptions = blockElement.querySelectorAll('.gin-type-option');
        this.subsequentOptions = blockElement.querySelectorAll('.subsequent-options');
        this.allSubsequentOptionButtons = blockElement.querySelectorAll('.subsequent-option');
        this.selectedType = null;
        this.selectedSubsequentOption = null;

        this.#init();
      }

      #init() {
        this.#addEventListeners();
      }

      #addEventListeners() {
        // Handle gin type selection
        this.typeOptions.forEach((option) => {
          if (!option._clickHandler) {
            option._clickHandler = () => this.#selectGinType(option);
          }
          option.removeEventListener('click', option._clickHandler);
          option.addEventListener('click', option._clickHandler);
        });

        // Handle subsequent option selection
        this.allSubsequentOptionButtons.forEach((button) => {
          if (!button._clickHandler) {
            button._clickHandler = () => this.#selectSubsequentOption(button);
          }
          button.removeEventListener('click', button._clickHandler);
          button.addEventListener('click', button._clickHandler);
        });
      }

      #selectGinType(option) {
        const type = option.dataset.type;

        // Clear previous selections
        this.typeOptions.forEach((opt) => opt.classList.remove('selected'));
        this.subsequentOptions.forEach((opt) => (opt.style.display = 'none'));
        this.allSubsequentOptionButtons.forEach((btn) => btn.classList.remove('selected'));

        // Select current type
        option.classList.add('selected');
        this.selectedType = type;
        this.selectedSubsequentOption = null;

        // Show relevant subsequent options
        let targetOptionsClass = '';
        if (type === 'old-tom-gin') {
          targetOptionsClass = '.old-tom-options';
        } else if (type === 'fruit-infused-gin') {
          targetOptionsClass = '.fruit-infused-options';
        } else if (type === 'pink-gin') {
          targetOptionsClass = '.pink-gin-options';
        }

        if (targetOptionsClass) {
          const targetOptions = this.blockElement.querySelector(targetOptionsClass);
          if (targetOptions) {
            targetOptions.style.display = 'block';
          }
        }

        // Dispatch custom event
        this.#dispatchGinTypeEvent();
      }

      #selectSubsequentOption(button) {
        // Clear selections within the same category
        const parentOptions = button.closest('.subsequent-options');
        parentOptions.querySelectorAll('.subsequent-option').forEach((btn) => btn.classList.remove('selected'));

        // Select current option
        button.classList.add('selected');
        this.selectedSubsequentOption = button.dataset.option;

        // Dispatch custom event
        this.#dispatchGinTypeEvent();
      }

      #dispatchGinTypeEvent() {
        document.dispatchEvent(
          new CustomEvent('gin-type-changed', {
            detail: {
              selectedType: this.selectedType,
              selectedSubsequentOption: this.selectedSubsequentOption,
            },
          })
        );
      }

      #getSelection() {
        return {
          selectedType: this.selectedType,
          selectedSubsequentOption: this.selectedSubsequentOption
        };
      }

      reset() {
        this.selectedType = null;
        this.selectedSubsequentOption = null;
        this.typeOptions.forEach((opt) => opt.classList.remove('selected'));
        this.subsequentOptions.forEach((opt) => (opt.style.display = 'none'));
        this.allSubsequentOptionButtons.forEach((btn) => btn.classList.remove('selected'));
      }
    }
  initiateGinTypeSelector();
}

document.addEventListener('DOMContentLoaded', () => {
  initiateGinTypeSelector();
});

document.addEventListener('modal-opened', () => {
  initiateGinTypeSelector();
});
